import React from "react";
import { formatCurrency } from "../../../lib/utils";

export default class ManualPayButton extends React.PureComponent {
  render() {
    const {
      currencyCode,
      errorMessage,
      loading,
      orderIncompleteFields,
      orderIsIncomplete,
      orderTotal,
      submitAttempted,
    } = this.props;

    return (
      <div className="flex flex-align-center flex-column mt-48 mb-120 mobile-mb-48">
        <button
          className="btn btn-rounded pointer"
          disabled={loading}
          type="submit"
        >
          {loading
            ? "Processing..."
            : `Pay ${formatCurrency(orderTotal, currencyCode)}`}
        </button>

        {submitAttempted && orderIsIncomplete ? (
          <p
            className="error-text text-center mt-16"
            style={{ padding: "0 16px" }}
          >
            Please complete required fields:{" "}
            {orderIncompleteFields && orderIncompleteFields.join(", ")}
          </p>
        ) : (
          errorMessage && (
            <div className="error-box flex-align-center">
              <i className="material-icons mr-8 large-text">warning</i>{" "}
              {errorMessage}
            </div>
          )
        )}
      </div>
    );
  }
}
